<template>
  <div class="distributor-box">
    <Alert type="warning" show-icon class="font-size-13">
      {{ $t('key1005603') }}
      {{ $t('key1005604') }}
      {{ $t('key1005605') }}
      {{ $t('key1005606') }}
    </Alert>
    <!--头部筛选区域-->
    <div class="filter-box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1005602')" prop="name">
              <Input v-model.trim="pageParams.name" :placeholder="$t('key1000324')" clearable></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001266')" prop="zoneCode">
              <Select v-model="pageParams.zoneCode">
                <Option v-for="item in responsibleAreaList" :key="item.zoneCode" :value="item.zoneCode">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col style="min-width: 170px;" push="1">
            <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation-box">
      <!--创建合规责任人-->
      <Button class="mr15" type="primary" v-if="getPermission('ymsCompliancePerson_create')"
        @click="$refs['complianceResponsiblePerson'].initComplianceResponsiblePersonData('add')">
        {{ $t('key1005607') }}
      </Button>
      <!--批量删除-->
      <Button class="mr15" type="primary" v-if="getPermission('ymsCompliancePerson_batchDelete')"
        @click="deleteComplianceResponsiblePerson('all')">{{ $t('key1002406') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="tableChange">
      </Table>
    </div>
    <!--分页区域-->
    <Page
      :transfer="true"
      v-if="!tableLoading"
      :total="total"
      class="distributor-page-box"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <!--合规责任人抽屉-->
    <complianceResponsiblePersonDrawer
      ref="complianceResponsiblePerson"
      :responsibleAreaList="responsibleAreaList"
      @updateData="pageParamsStatus = true">
    </complianceResponsiblePersonDrawer>
    <!--关联商品抽屉-->
    <relatedProductsDrawer
      @updateData="pageParamsStatus = true"
      :responsibleAreaList="responsibleAreaList"
      ref="relatedProductsDrawer">
    </relatedProductsDrawer>
    <!--关联商品弹窗-->
    <relatedProductsModal ref="relatedProducts"></relatedProductsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import complianceResponsiblePersonDrawer from '@/views/distributor/components/complianceInfoManage/complianceResponsiblePersonDrawer';
import relatedProductsModal from '@/views/distributor/components/complianceInfoManage/relatedProductsModal';
import relatedProductsDrawer from '@/views/distributor/components/complianceInfoManage/relatedProductsDrawer';
import {commonLocalStorage, getAllUsersInfo, getCountryZoneData, getUserNameByUserId} from "@/utils/common";

export default {
  name: 'complianceResponsiblePersonList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        name: '',
        zoneCode: null,
        pageNum: 1,
        pageSize: 15
      },
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005599'),
          key: 'name',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005600'),
          key: 'zoneCode',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            let zoneCode = params.row.zoneCode;
            let text = '-';
            v.responsibleAreaList.map((item) => {
              if (item.zoneCode === zoneCode) {
                text = item.name;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005584'),
          key: 'relatedProducts',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            let productCount = params.row.productCount;
            let ymsCompliancePersonId = params.row.ymsCompliancePersonId;
            return h('Alink', {
              props: {
                linkName: productCount,
                textAlign: 'center',
                className: 'justify-content-center',
                AlinkShow: true
              },
              on: {
                AlinkBtn: () => {
                  v.$refs['relatedProducts'].initRelatedProductsData('responsiblePerson', ymsCompliancePersonId);
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          align: 'center',
          minWidth: 170,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158'),
          key: 'createdBy',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            return h('div', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 210,
          render: (h, params) => {
            let ymsCompliancePersonId = params.row.ymsCompliancePersonId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002184'),
                    show: v.getPermission('ymsCompliancePerson_update'),
                    clickFn: () => {
                      v.$refs['complianceResponsiblePerson'].initComplianceResponsiblePersonData('edit', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005584'),
                    show: v.getPermission('ymsCompliancePerson_insertCompliancePersonProducts'),
                    clickFn: () => {
                      v.$refs['relatedProductsDrawer'].initRelatedProductsDrawerData('complianceResponsiblePerson', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.getPermission('ymsCompliancePerson_batchDelete'),
                    clickFn: () => {
                      v.deleteComplianceResponsiblePerson('single', ymsCompliancePersonId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      total: 0,
      responsibleAreaList: [],
      selectTableData: [],
      userInfoList:{}
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
        });
        await getCountryZoneData().then((data) => {
          this.responsibleAreaList = data;
        });
        this.search();
      })();
    },
    // 重置按钮
    reset() {
      let v = this;
      if (v.$refs['pageParams']) {
        v.$refs['pageParams'].resetFields();
      }
      v.getList();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.total = 0;
      v.optionBtnWidth = [];
      v.tableData = [];
      if (v.getPermission('ymsCompliancePerson_query')) {
        v.axios.post(api.post_ymsCompliancePerson_query, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.tableLoading = false;
            }
            setTimeout(() => {
              let value = commonLocalStorage.getItem('autoCreate') || '';
              if (value) {
                v.$nextTick(() => {
                  if (v.$refs['complianceResponsiblePerson']) {
                    v.$refs['complianceResponsiblePerson'].initComplianceResponsiblePersonData('add');
                  }
                });
              }
              commonLocalStorage.removeItem('autoCreate');
            }, 2000);
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data;
      }
    },
    // 删除合规责任人
    deleteComplianceResponsiblePerson(type, ymsCompliancePersonId) {
      let v = this;
      let content = '';
      let ymsCompliancePersonIds = [];
      if (type === 'single') {
        ymsCompliancePersonIds = [ymsCompliancePersonId];
        content = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005585');
      } else {
        if (v.selectTableData.length > 0) {
          content = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005581')}<span class="distributorThemeColor ml2 mr2">${v.selectTableData.length}</span>${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005598')}`;
          ymsCompliancePersonIds = v.selectTableData.map((item) => {
            return item.ymsCompliancePersonId;
          });
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005601'));
          return false;
        }
      }
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002162'),
        content: content,
        dangerouslyUseHTMLString: true,
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005587'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.post(api.post_ymsCompliancePerson_batchDelete, ymsCompliancePersonIds,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.selectTableData = [];
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000779'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {

        }
      });
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
  },
  components: {
    complianceResponsiblePersonDrawer,
    relatedProductsModal,
    relatedProductsDrawer
  },
};
</script>

<style lang="less">

</style>
